import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const SIEM: React.FC = () => {
  const sections = [
    {
      title: 'Security Information and Event Management (SIEM)',
      content: 'Our SIEM solutions provide centralized security monitoring, log management, and threat detection capabilities. We deploy and manage enterprise-grade SIEM platforms that collect, analyze, and correlate security events from across your entire IT infrastructure.',
      benefits: [
        'Centralized log collection and management',
        'Real-time security event correlation and analysis',
        'Advanced threat detection and alerting',
        'Compliance reporting and audit trails',
        'Security incident investigation and forensics'
      ]
    }
  ];

  return (
    <ServiceTemplate
      title="Security Information & Events Management"
      subtitle="Enterprise SIEM solutions for centralized security monitoring, threat detection, and compliance management."
      sections={sections}
    />
  );
};

export default SIEM;

